var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"real-time-pie"},[_c('p',{staticClass:"pie-device-status"},[_vm._v(_vm._s(_vm.$t('yin_pin_bang_dan'))+" Top10")]),_c('div',{staticClass:"real-time-pie-chart",attrs:{"id":"top10DrinkPieChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }